import React, { Component } from 'react'
import { observer } from 'mobx-react'

import Modal from '../../../../UniformComponents/Modal'
import Button from '../../../../UniformComponents/Button'
import Input from '../../../form/Input'
import Date from '../../../form/Date'
import RadioGroup from '../../../form/RadioGroup'
import CheckboxGroup from '../../../form/CheckboxGroup'
import Select from '../../../form/Select'
import Switch from '../../../../UniformComponents/Switch'

@observer
class LicenceGroup extends Component {
    render() {
        const { store, show } = this.props
        const { licenceGroup } = store

        return (
            <Modal
                id="licenceGroup"
                show={show}
                onClose={() => store.toggleModal('licenceGroup')}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '20px',
                    }}
                >
                    <Input
                        onBlur={store.updateLicenceGroup}
                        label="Licence group name"
                        name="name"
                        defaultValue={licenceGroup.name}
                    />

                    <Input
                        onBlur={store.updateLicenceGroup}
                        label="Licence owner"
                        name="owner"
                        defaultValue={licenceGroup.owner}
                        isNumeric
                    />

                    <Input
                        onBlur={store.updateLicenceGroup}
                        label="CRM reference"
                        name="crmReference"
                        defaultValue={licenceGroup.crmReference}
                    />

                    <Switch
                        name="licenceExcempt"
                        label="Licence excempt"
                        isLeft
                        optimisticUpdate={false}
                        state={licenceGroup.licenceExcempt}
                        onToggle={(toggled) => { store.updateLicenceGroup({ value: toggled, name: 'licenceExcempt' }) }}
                    />

                    {Boolean(licenceGroup.licenceExcempt) && (
                        <Input
                            onBlur={store.updateLicenceGroup}
                            label="Licence excempt reason"
                            name="licenceExcemptReason"
                            defaultValue={licenceGroup.licenceExcemptReason}
                        />
                    )}

                    <div
                        className="form-checkbox-grp"
                    >
                        <label className="checkbox-grp-label">
                            Industry
                        </label>

                        <RadioGroup
                            onBlur={store.updateLicenceGroup}
                            refreshOnRender
                            defaultChecked={licenceGroup.industry}
                            name="industry"
                            options={store.industries}
                        />
                    </div>

                    <div
                        className={`form-checkbox-grp`}
                    >
                        <label className="checkbox-grp-label">
                            Event type
                        </label>

                        <RadioGroup
                            onBlur={store.updateLicenceGroup}
                            refreshOnRender
                            defaultChecked={licenceGroup.eventType}
                            name="eventType"
                            options={store.eventTypes}
                        />
                    </div>

                    <CheckboxGroup
                        onBlur={store.updateLicenceGroup}
                        refreshOnRender
                        defaultChecked={licenceGroup.feature}
                        label="Feature flags"
                        name="feature"
                        returnValueUnchanged
                        options={store.licenceAddons}
                    />

                    <Date
                        label="Activation start date"
                        name="startDate"
                        dateFormat="YYYY-MM-DD"
                        showTimeSelect={false}
                        value={licenceGroup.startDate}
                        allowManualDateEdit
                        onBlur={store.updateLicenceGroup}
                    />

                    <Input
                        onBlur={store.updateLicenceGroup}
                        label="Back stop expiry"
                        name="expiryDate"
                        defaultValue={licenceGroup.expiryDate}
                    />

                    <Input
                        onBlur={store.updateLicenceGroup}
                        label="Licence period"
                        name="period"
                        isNumeric
                        defaultValue={licenceGroup.period}
                    />

                    <Select
                        onBlur={store.updateLicenceGroup}
                        label="Licence type"
                        name="licenceType"
                        value={licenceGroup.licenceType}
                        options={[
                            {
                                value: 'standard',
                                label: 'Standard',
                            },
                            {
                                value: 'rapid',
                                label: 'Rapid',
                            },
                        ]}
                    />

                    <Input
                        onBlur={store.updateLicenceGroup}
                        defaultValue={licenceGroup.licenceCount}
                        label="Number of licences"
                        name="licenceCount"
                        isNumeric
                    />

                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Button
                            label="Cancel"
                            variant="tertiary"
                            cssClass="regular"
                            onClick={() => store.toggleModal('licenceGroup')}
                        />

                        <Button
                            label="Save"
                            variant="primary"
                            cssClass="regular"
                            onClick={store.saveLicenceGroup}
                        />
                    </div>
                </div>
            </Modal>
        )
    }
}

export default LicenceGroup
